import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

const ComboAccesoSistema = ({
  value,
  onChange,
  name,
  error = false,
  helperText = null,
  fullWidth = false,
  disabled = false,
  required = false,
}) => {
  return (
    <FormControl
      variant="outlined"
      size="small"
      error={error}
      disabled={disabled}
      fullWidth={fullWidth}
      required={required}
    >
      <InputLabel id={`${name}Label`}>Tiene acceso</InputLabel>
      <Select
        labelId={`${name}Label`}
        id={name}
        name={name}
        label={`Tiene acceso${required ? "*" : ""}`}
        value={value}
        onChange={(e) => onChange(e)}
      >
        <MenuItem value="Todos" >Todos</MenuItem>
        <MenuItem value="SI">SI</MenuItem>
        <MenuItem value="NO">NO</MenuItem>
        
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default ComboAccesoSistema;
